import styled from 'styled-components'
import { Flex } from '@rebass/grid'

export const StyledRow = styled(Flex)`
  justify-content: center;
`

export const InnerContainer = styled(Flex)`
  flex-wrap: wrap;
  margin-left: auto;
  margin-right: auto;
  position: relative;
  width: 100%;
`

export const OuterContainer = styled.div`
  max-width: 1340px;
  width: 100%;
`
